"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Colors = require("../00_environment/Colors");

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _Icon = _interopRequireDefault(require("../01_atoms/Icon"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _PlaceHolderElement = _interopRequireDefault(require("../01_atoms/PlaceHolderElement"));

var _KeyValueElement = _interopRequireDefault(require("../01_atoms/KeyValueElement"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var EditPassengersWidget = function EditPassengersWidget(_ref) {
  var _ref$userPassengerId = _ref.userPassengerId,
      userPassengerId = _ref$userPassengerId === void 0 ? null : _ref$userPassengerId,
      _ref$savedPassengers = _ref.savedPassengers,
      savedPassengers = _ref$savedPassengers === void 0 ? [] : _ref$savedPassengers,
      _ref$onPassengerEdit = _ref.onPassengerEdit,
      onPassengerEdit = _ref$onPassengerEdit === void 0 ? function () {} : _ref$onPassengerEdit,
      _ref$addPassengerLink = _ref.addPassengerLink,
      addPassengerLink = _ref$addPassengerLink === void 0 ? '' : _ref$addPassengerLink,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      t = _ref.translator;
  var saved = savedPassengers || [];
  var addPassengerColor = _Colors.thirdColor;
  saved.sort(function (a, b) {
    return a.firstName > b.firstName ? 1 : -1;
  });
  return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Edit known passengers')
  }, /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: t('List of known passengers'),
    subtitle: t('Book tickets faster by saving you and your friends details here'),
    titlePadding: 10,
    backgroundColor: "white"
  }, !_checkTypes["default"].nonEmptyArray(saved) && /*#__PURE__*/_react["default"].createElement(_PlaceHolderElement["default"], null, t('No passenger saved yet')), saved.map(function (p) {
    var title = "".concat(p.firstName, " ").concat(p.lastName);

    if (userPassengerId === p.id) {
      title = /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }
      }, /*#__PURE__*/_react["default"].createElement("span", null, title), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Label, {
        color: "purple",
        horizontal: true,
        style: {
          marginLeft: 15
        }
      }, t('You')));
    }

    return /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
      style: {
        cursor: 'pointer'
      },
      onClick: function onClick() {
        return onPassengerEdit(p);
      },
      title: /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          width: '100%',
          height: '100%',
          cursor: 'pointer'
        }
      }, title),
      value: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "angle right",
        style: {
          color: 'gray',
          cursor: 'pointer',
          marginLeft: 15,
          marginBottom: 1
        }
      })
    });
  })), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    to: addPassengerLink,
    fluid: true,
    style: {
      marginBottom: 15
    },
    color: addPassengerColor
  }, t('Add passenger'))), /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onBack,
    fluid: true
  }, t('Back')))));
};

var _default = EditPassengersWidget;
exports["default"] = _default;